import {DEBUG} from "../settings";
import {message} from "antd";
import dayjs from "dayjs";

export function createFormDataByJson(values){
    const formData = new FormData()
        Object.keys(values).forEach((key) => {
            formData.append(key, values[key])
        })
    return formData
}

export const BuildFieldErrorsDict = (error, setValidatedFields, toastMessage = false) => {

    DEBUG && console.error('catch', error)
    toastMessage && message.error(toastMessage)

    if (error.response) {

        DEBUG && console.error('response', error.response)
        const {
            errors: errorsBack,
            code: errorCode=null
        } = error.response.data;
        if (errorCode === 'field_error') {
            let errors = []
            let automationErrorMessage = ''
            if ('automation_errors' in errorsBack) {

                let count = 1
                errorsBack.automation_errors.forEach((error, index) => {
                    if ('field' in error) {
                        errorsBack[error.field] = [error.error]
                    }
                    automationErrorMessage += `${index + 1} - ${error.error}\n`

                })
            }

            let generalErrorMessages = [] // Armazena erros que não são de campos específicos

            Object.entries(errorsBack).forEach((value) => {
                const fieldName = value[0]
                let erro = value[1]
                if (!(value[1] instanceof Array)) erro = [value[1]]

                // Sempre adiciona erros de campo se setValidatedFields existe
                if (setValidatedFields) {
                    errors.push({name: fieldName, errors: erro})
                }

                // Também acumula todos os erros para possível exibição geral
                // Isso garante que erros de campos inexistentes também sejam mostrados
                generalErrorMessages.push(...erro)

            })
            if (automationErrorMessage) {
                message.error(automationErrorMessage, 5)
            } else if (generalErrorMessages.length > 0) {
                // Sempre exibe uma notificação com os erros específicos
                const uniqueMessages = [...new Set(generalErrorMessages)]

                // Se há formulário, mostra uma mensagem mais genérica junto com os erros específicos
                if (setValidatedFields) {
                    message.error(`${uniqueMessages.join('\n')}\n\nVerifique também os campos destacados no formulário.`, 5)
                } else {
                    // Se não há formulário, mostra só os erros específicos
                    message.error(uniqueMessages.join('\n'), 5)
                }
            } else {
                message.error('Corrija os campos')
            }
            setValidatedFields && setValidatedFields(errors)
        } else if (error.response.data?.errors || error.response.data?.detail) {
            let response_errors = error.response.data.errors || error.response.data.detail
            if (response_errors) {
                if (Array.isArray(response_errors)) {
                    message.error(response_errors[0])
                } else {
                    message.error(response_errors)
                }
            }
        } else if (error.response.data?.non_field_errors) {
            const non_field_errors = error.response.data.non_field_errors
            if (Array.isArray(non_field_errors)) {
                message.error(non_field_errors[0])
            } else {
                message.error(non_field_errors)
            }
        } else {

            showDefaultError()
        }
    } else {
        showDefaultError(error)
    }

}

function showDefaultError(error) {
    const DEFAULT_ERROR_MESSAGE = 'Ocorreu um erro inesperado, por favor contate o suporte.'
    if (navigator.onLine) {
        if (error?.message) {
             message.error(error.message)
        } else {
             message.error(DEFAULT_ERROR_MESSAGE)
        }
    } else {
         message.warning('Você está sem conexão com a internet. Por isso, o sistema não conseguirá acessar as informações e alguns erros podem ocorrer.')
    }
}

export function clearCpfMask(value = '') {
    return value.toString().replace(/([^\d])/g, '')
}

export function cfpMask(value) {

    let number = clearCpfMask(value);

    if (number === '') {
        return ``
    }
    const limit = 11
    if (number.length > limit) {
        number = number.substring(0, 11)
    }
    if (number.length > 2) {
        number = `${addNumberPointsBySteps(number.slice(0, (number.length - 2)))}-${number.slice(-2)}`//x.xxx,xx ...
    }

    return number
}

function addNumberPointsBySteps(value, steps = 3) {
    let finalNumber = ''
    let numberSteps = steps * -1
    while (true) {
        let lastNumber = value.slice(numberSteps)
        if (lastNumber) {
            if (finalNumber) {
                finalNumber = `${lastNumber}.${finalNumber}`
            } else {
                finalNumber = lastNumber
            }
            let indexToSlice
            if (value.length < steps) {
                indexToSlice = numberSteps
            } else {
                indexToSlice = (value.length - steps)
            }
            value = value.slice(0, indexToSlice)
        } else {
            break;
        }
    }
    return finalNumber
}

export function clearCpfCnpjMask(value = '') {
    if (!value) return value
    return value.toString().replace(/([^\d])/g, '').substring(0, 14)
}

export function phoneMask(value) {
    let cleanedValue = clearCpfCnpjMask(value)
    return genericMask(cleanedValue, "(00) 0 0000-0000")
}

export function clearPhoneMask(value = '') {
    if (!value) return value
    return value.toString().replace(/([^\d])/g, '').substring(0, 11)
}


export function genericMask(value, mask) {
    /**
     * exemplo de mascara: ["000.000.000-000", "00.000.00000/000", "00.000.000/0000-00"];
     * */
    if (!value || !mask) return value

    let cleanedValue = String(value).replaceAll(/\D/g, '')
    let cleanedMask = mask.replaceAll(/\D/g, '')

    if (cleanedValue.length === 0) return value

    const limitCaracter = cleanedMask.length
    if (cleanedValue.length > limitCaracter) {
        cleanedValue = cleanedValue.substring(0, limitCaracter)
    }
    const reverseMask = Array.from(mask).reverse()
    const reverseValue = Array.from(cleanedValue).reverse()

    let newValue = '';


    // let valueIndex = 0
    // reverseValue.forEach((valueCarater,) => {
    //     let maskCaracter = reverseMask[valueIndex]
    //     if (maskCaracter !== '0') {
    //         valueIndex += 2
    //         newValue = `${valueCarater}${maskCaracter}${newValue}`
    //     } else {
    //         valueIndex++
    //         newValue = `${valueCarater}${newValue}`
    //     }
    //
    // })
    let valueIndex = 0
    reverseMask.forEach((maskCaracter,) => {
        // let maskCaracter = reverseMask[valueIndex]
        if (reverseValue.length > valueIndex) {
            if (maskCaracter !== '0') {
                // valueIndex += 2
                newValue = `${maskCaracter}${newValue}`
            } else {

                newValue = `${reverseValue[valueIndex++]}${newValue}`
            }
        } else {
            if (cleanedMask.length === cleanedValue.length) {
                newValue = `${maskCaracter}${newValue}`
            }
        }
    })

    return newValue
}

export function moneyMask(value = 0, negative = false) {
    const isNegativeCaractere = value?.toString()?.charAt(0) === '-'
    const negativeCaractere = isNegativeCaractere ? '-' : ''
    if (!value || (value?.length === 1 && isNegativeCaractere)) return value
    const _value = Number(value).toFixed(2)
    return `${negativeCaractere}${genericMask(_value, '0.000.000.000,00')}`

}


export function dateFormat(date, format = 'DD/MM/YYYY') {

    if (date) return dayjs(date).format(format)
    return ''
}

export function getStartMonth() {
    return dayjs().startOf('month')
}

export function getEndMonth() {
    return dayjs().endOf('month')
}

export function clearMoneyMask(value = '', negative = false, formatToBack = true) {
    let newValue

    const isNegativeCaractere = negative && value?.charAt(0) === '-'
    newValue = value.toString().replace(/([^\d]|^0*)/g, '')

    // if(value.length === 1 && value === '0') return '0'

    if (!isNegativeCaractere && !newValue && Number(value.toString().replace(/([^\d])/g, '')) === 0) return '0'

    const negativeCaractere = isNegativeCaractere ? '-' : ''
    if (formatToBack) {


        if (newValue == 0) {
            newValue = ''
        } else if (newValue.length === 1) {
            newValue = `0.0${newValue}`
        } else if (newValue.length === 2) {
            newValue = `0.${newValue}`
        } else if (newValue.length > 2) {
            newValue = genericMask(newValue, '0000000000.00')
        }
    }

    return `${negativeCaractere}${newValue}`
}
